<nz-spin [nzSpinning]="isSpinning">
  <div class="page-content container">
    <div class="title-box">
      <span class="title">{{ "OPERATION_LOG" | translate }}</span>
    </div>
    <div class="filter-box">
      <div class="filter-list">
        <div class="filter-item">
          <span>{{ "PROJECT_MODULE" | translate }}</span>
          <nz-input-group [nzSuffix]="projectModule">
            <input
              nz-input
              [placeholder]="
                'PLACEHOLDER_PLEASE_INPUT'
                  | translate : { name: 'PROJECT_MODULE' | translate }
              "
              [(ngModel)]="params.projectModule"
            />
          </nz-input-group>
          <ng-template #projectModule>
            <i
              nz-icon
              class="ant-input-clear-icon"
              nzTheme="fill"
              nzType="close-circle"
              *ngIf="params.projectModule"
              (click)="params.projectModule = ''"
            ></i>
          </ng-template>
        </div>
        <div class="filter-item">
          <span>{{ "FUNCTION_NAME" | translate }}</span>
          <nz-input-group [nzSuffix]="functionName">
            <input
              nz-input
              [placeholder]="
                'PLACEHOLDER_PLEASE_INPUT'
                  | translate : { name: 'FUNCTION_NAME' | translate }
              "
              [(ngModel)]="params.functionName"
            />
          </nz-input-group>
          <ng-template #functionName>
            <i
              nz-icon
              class="ant-input-clear-icon"
              nzTheme="fill"
              nzType="close-circle"
              *ngIf="params.functionName"
              (click)="params.functionName = ''"
            ></i>
          </ng-template>
        </div>
      </div>
      <div class="filter-ctrl">
        <button nz-button nzType="primary" (click)="onSearch()">
          <i nz-icon nzType="search" nzTheme="outline"></i>
          <span>{{ "SEARCH" | translate }}</span>
        </button>
        <button nz-button nzType="default" (click)="onClear()">
          <i nz-icon nzType="close" nzTheme="outline"></i>
          <span>{{ "CLEAR" | translate }}</span>
        </button>
      </div>
    </div>
    <div class="container">
      <nz-table
        #basicTable
        [nzData]="dataSource"
        [nzFrontPagination]="false"
        [nzServerRender]="true"
        [nzTotal]="pagination.total"
        [nzPageIndex]="pagination.pageIndex"
        [nzPageSize]="pagination.pageSize"
        [nzPageSizeOptions]="pagination.pageSizeOptions"
        (nzPageIndexChange)="pageIndexChange($event)"
        (nzPageSizeChange)="pageSizeChange($event)"
        [nzScroll]="{ y: 'calc(100vh - 380px)' }"
        nzShowSizeChanger
        nzShowQuickJumper
        [nzShowTotal]="totalTemplate"
        [nzWidthConfig]="widthConfig"
      >
        <thead>
          <tr>
            <th *ngFor="let col of columns">{{ col.name | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of basicTable.data">
            <td *ngFor="let col of columns">
              <ng-container *ngIf="col.key !== 'operResult'">
                <span>{{ data[col.key] }}</span>
              </ng-container>
              <ng-container *ngIf="col.key === 'operResult'">
                <span [title]="data[col.key]" class="two-lines-ellipsis">{{
                  data[col.key]
                }}</span>
              </ng-container>
            </td>
          </tr>
        </tbody>
      </nz-table>
      <ng-template #totalTemplate let-total>{{
        "TOTAL_ITEM" | translate : { total }
      }}</ng-template>
    </div>
  </div>
</nz-spin>
